import * as Sentry from "@sentry/capacitor";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import { AgentStage } from "@/Modules/Agent/Models/Domain";

import { getSuggestions } from "@/Services/TherapyApi/Agent";
import SuggestionTransformer from "@/Modules/Transformers/Agent/Suggestion";

import useAgentStore from "@/Modules/Agent/Store";
import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";

async function fetchSuggestionsAH(customerUuid: string) {
  const agentStore = useAgentStore();
  const appStore = useAppStore();

  agentStore.agentStage = AgentStage.LOADING;

  try {
    const suggestionsApi = await getSuggestions(customerUuid);
    const suggestionsDomain = suggestionsApi.map(SuggestionTransformer.toDomain);

    agentStore.suggestions = suggestionsDomain;
  } catch (error) {
    danger(error);
    Sentry.captureException(error);
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    agentStore.agentStage = null;
  }
}

export default fetchSuggestionsAH;
